import { connect } from "react-redux";
import MarcarEnviadoModal from "./MarcarEnviadoModal";
import { actions } from "../../../../../redux/modules/orden_online/orden_online";

const ms2p = (state) => {
    return {
        ...state.ordenes_online,
    };
};

const md2p = {
    ...actions,
};

export default connect(ms2p, md2p)(MarcarEnviadoModal);
